import { ResourceService } from '../services'
import { ResourceSupport } from '../support/ResourceSupport'

export const useResources = () => {
  const alt = useAlt()

  return {
    get service() {
      return alt.get(ResourceService)
    },
    get support() {
      return alt.get(ResourceSupport)
    },
  }
}
